import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Auth0Provider } from "@auth0/auth0-react";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const providerConfig = {
  
  domain: "dev-rcr3spne0z56bbec.us.auth0.com",
  clientId: "fDckjo5fEYn47fjnmluGUZKnlpsa8K0t",
  authorizationParams: {
    redirect_uri: window.location.origin + "/",
  }
};

// Create a client
const queryClient = new QueryClient({
  staleTime: 10000,
  retry: 3,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Auth0Provider {...providerConfig}>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <App />
      </Provider>
    </QueryClientProvider>
  </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA- ok 
reportWebVitals();
